import * as S from "@/containers/Project/components/styled";
import { CONTENT_WIDTH } from "@/enums";
import { useProjectContext } from "@/providers";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Input, Popconfirm, Select } from "antd";
import { func, number, object, string } from "prop-types";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

const { Option } = Select;

const maxCharacterLength = 20;
const EditSchedule = ({
  schedule,
  index,
  label,
  handleDelete,
  handleRename,
  handleChangeStartingMilestone,
}) => {
  const intl = useIntl();
  const { project } = useProjectContext();

  const [startMilestoneOptions, setStartMilestoneOptions] = useState([]);

  const handleInputChange = (event) => {
    handleRename(schedule, event.target.value);
  };

  const handleSelectChange = (event) => {
    handleChangeStartingMilestone(schedule, event);
  };

  useEffect(() => {
    if (!project?.schedules?.[0]?.milestones?.length) return;

    const options = project.schedules[0].milestones
      .filter(
        (milestone) =>
          !milestone.shouldCompleteProject &&
          !milestone.secureProjectOnCompletion
      )
      .map((milestone) => ({
        id: milestone.id,
        name: milestone.displayName || milestone.name,
      }));
    setStartMilestoneOptions(options);
  }, [project]);

  return (
    <>
      <S.ScheduleRow align={"bottom"}>
        <Col span={CONTENT_WIDTH.max - 1}>
          <S.ScheduleInput>
            <span> {label} </span>
            <Input
              data-test-id={"schedule-name-input"}
              value={schedule.name}
              onChange={handleInputChange}
              maxLength={maxCharacterLength}
              status={
                !schedule.name || !schedule.name.trim().length ? "error" : null
              }
            />
          </S.ScheduleInput>
        </Col>
        {index !== 0 && (
          <Col span={1}>
            <Popconfirm
              title={
                intl.formatMessage({
                  id: "addScheduleModal.confirmDelete",
                }) +
                ` (${intl.formatMessage({
                  id: "addScheduleModal.confirmExtended",
                })})`
              }
              okText={intl.formatMessage({ id: "general.delete" })}
              cancelText={intl.formatMessage({ id: "general.cancel" })}
              onConfirm={() => handleDelete(index)}
              data-test-id="schedule-delete-confirm"
            >
              <Button
                data-test-id={`remove-schedule-${index}`}
                icon={<FontAwesomeIcon icon={faTrash} />}
              />
            </Popconfirm>
          </Col>
        )}

        <div
          className={
            schedule.name.length > maxCharacterLength
              ? "text-red-600"
              : schedule.name.length === maxCharacterLength
              ? "text-yellow-600"
              : ""
          }
        >
          {schedule.name.length} / {maxCharacterLength}
        </div>
      </S.ScheduleRow>
      {!schedule.id && !!startMilestoneOptions.length && (
        <S.ScheduleRow align={"bottom"}>
          <Col span={CONTENT_WIDTH.max - 2} offset={CONTENT_WIDTH.single}>
            <S.ScheduleInput>
              <span>
                {intl.formatMessage(
                  { id: "addScheduleModal.startSchedule" },
                  { scheduleName: schedule.name }
                )}
              </span>
              <Select
                data-test-id={`edit-schedule-${index}-select-milestone`}
                value={schedule.tempStartingMilestone}
                placeholder={intl.formatMessage({
                  id: "addScheduleModal.selectMilestone",
                })}
                onChange={handleSelectChange}
              >
                {startMilestoneOptions.map(({ id, name }) => (
                  <Option key={id} value={id}>
                    {name}
                  </Option>
                ))}
              </Select>
            </S.ScheduleInput>
          </Col>
        </S.ScheduleRow>
      )}
    </>
  );
};

EditSchedule.propTypes = {
  schedule: object,
  index: number.isRequired,
  label: string,
  handleDelete: func,
  handleRename: func,
  handleChangeStartingMilestone: func,
};

export { EditSchedule };
